import { replace } from "lodash";
import numeral from "numeral";

// ----------------------------------------------------------------------

export function fCurrency(number) {
  return numeral(number).format(Number.isInteger(number) ? "$0,0" : "$0,0.00");
}

export function fCurrencyWithoutSign(number) {
  return numeral(number).format("00.00");
}

export function fPercent(number) {
  return numeral(number / 100).format("0.00%");
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return replace(numeral(number).format("0.00a"), ".00", "");
}

export function fData(number) {
  return numeral(number).format("0.0 b");
}

export function formatCurrency(num) {
  const isNegative = num < 0;
  num = Math.abs(num);

  let suffix = "";
  let formattedNumber = num;

  if (num >= 1e12) {
    formattedNumber = (num / 1e12).toFixed(1);
    suffix = "T";
  } else if (num >= 1e9) {
    formattedNumber = (num / 1e9).toFixed(1);
    suffix = "B";
  } else if (num >= 1e6) {
    formattedNumber = (num / 1e6).toFixed(1);
    suffix = "M";
  } else if (num >= 1e3) {
    formattedNumber = (num / 1e3).toFixed(1);
    suffix = "K";
  }

  formattedNumber = formattedNumber.toString();

  if (formattedNumber.endsWith(".0")) {
    formattedNumber = formattedNumber.slice(0, -2);
  }

  const result = `$${formattedNumber}${suffix}`;

  return isNegative ? `-${result}` : result;
}
